import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import { float6Normalizer } from "validators";
import {
	applyValidatorsIf,
	floatToSixValidation,
	maxValue100,
	onlyPercentToSixFloat,
} from "validators/validation";

import styles from "./tabsChoose.module.scss";

const DualFlatRate = ({ setCurrentValueInField, isPaperApplication }) => {
	const handleChange = () => setCurrentValueInField(true);
	const isDualFlatRate = (_value, allValues) =>
		allValues.feeProgram === "DualFlatRate";

	return (
		<div>
			<div className={styles.subHeader}>Dual Flat Rate Pricing</div>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(isDualFlatRate)([
							maxValue100,
							floatToSixValidation,
						])}
						normalize={onlyPercentToSixFloat}
						label="Card Present Rate, %"
						name="dualFlatRateCardPresent"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleChange}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(isDualFlatRate)([
							floatToSixValidation,
						])}
						normalize={onlyPercentToSixFloat}
						label="Card Present Authorization Fee, $"
						name="dualFlatRateCardPresentAuthFee"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleChange}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(isDualFlatRate)([
							maxValue100,
							floatToSixValidation,
						])}
						normalize={onlyPercentToSixFloat}
						label="Card Not Present Rate, %"
						name="dualFlatRateCardNotPresent"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleChange}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(isDualFlatRate)([
							floatToSixValidation,
						])}
						normalize={onlyPercentToSixFloat}
						label="Card Not Present Authorization Fee, $"
						name="dualFlatRateCardNotPresentAuthFee"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleChange}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default memo(DualFlatRate);
